/* eslint-disable consistent-return */
/* eslint-disable complexity */
/* eslint-disable max-statements */

import { isEmpty } from 'lodash';

function handlePrefill(data, profileData, setProfileData) {
  const formToBeSet = {};

  if (isEmpty(data)) {
    return;
  }

  if (!isEmpty(data.form_1_data)) {
    const formData = data.form_1_data;
    const isMentor = formData.is_mentor;
    const isMentee = formData.is_mentee;

    if (isMentee && isMentor) {
      formToBeSet.mentorship_type = ['mentor', 'mentee'];
    } else if (isMentee) {
      formToBeSet.mentorship_type = ['mentee'];
    } else if (isMentor) {
      formToBeSet.mentorship_type = ['mentor'];
    }
  }

  if (!isEmpty(data.form_2_data)) {
    setProfileData({ ...profileData, ...data.form_2_data?.profile });
  }

  if (!isEmpty(data.form_3_data)) {
    const { services: mentorServices } = data.form_3_data;
    formToBeSet.mentor_services = mentorServices.map((service) => service.id);
  }

  if (!isEmpty(data.form_4_data)) {
    const { services: menteeServices } = data.form_4_data;
    formToBeSet.mentee_services = menteeServices.map((service) => service.id);
  }

  return formToBeSet;
}

export default handlePrefill;
